export const SUB_OBJECT_PAGE_LEVEL = 60;

export const OBJECT_PAGE_LEVEL = 40;

export const LISTING_PAGE_LEVEL = 20;
